<template>
    <div>
        <!--        修改密码对话框 start -->
        <Modal footer-hide v-model="isShowChangePassword" :title="$t('message.changePassword.title')"
               :mask-closable="false" @on-visible-change="changeShowStatus">
            <Form ref="changePassword" :model="changePassword" :rules="changePasswordValidate">
                <FormItem :label="$t('message.changePassword.oldPassword')" prop="oldPassword">
                    <i-input type="password" v-model="changePassword.oldPassword" :placeholder="$t('message.changePassword.oldPassword')" clearable>
                        <Icon type="md-key" size="18" slot="prepend" />
                    </i-input>
                </FormItem>
                <FormItem :label="$t('message.changePassword.newPassword')" prop="newPassword">
                    <i-input type="password" v-model="changePassword.newPassword" :placeholder="$t('message.changePassword.newPassword')" clearable>
                        <Icon type="md-lock" size="16" slot="prepend" />
                    </i-input>
                </FormItem>
                <FormItem :label="$t('message.changePassword.confirmPassword')" prop="confirmPassword">
                    <i-input type="password" v-model="changePassword.confirmPassword" :placeholder="$t('message.changePassword.confirmPasswordPlaceholder')" clearable>
                        <Icon type="md-lock" size="16" slot="prepend" />
                    </i-input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="submitChangePassword" class="submit-button">
                        <span class="button-text">{{$t('message.changePassword.submitButton')}}</span>
                    </Button>
                    <Button type="default" @click="resetFields" class="submit-button">
                        <span class="button-text">{{$t('message.changePassword.resetButton')}}</span>
                    </Button>
                </FormItem>
            </Form>
        </Modal>
        <!--        修改密码对话框 end -->
    </div>
</template>

<script>

  import {urlRequest} from "../../common/common";

  export default {
    name: "ChangePassword",

    data() {
      // 两次密码输入是否一致校验
      const confirmPasswordValidate = (rule, value, callback) => {
        if (this.changePassword.newPassword !== this.changePassword.confirmPassword) {
          callback(new Error(this.$t('message.changePassword.confirmPasswordSomeValidate')));
        }
        callback();
      };
      return {

        // 修改密码表单
        changePassword: {
          // 旧密码
          oldPassword: '',
          // 新密码
          newPassword: '',
          // 新密码确认
          confirmPassword: '',
        },
        // 修改密码表单验证规则
        changePasswordValidate: {
          oldPassword: [
            { required: true, message: this.$t('message.changePassword.oldPasswordValidate'), trigger: 'blur' },
          ],
          newPassword: [
            { required: true, message: this.$t('message.changePassword.newPasswordEmptyValidate'), trigger: 'blur' },
            { type: 'string', min: 6, message: this.$t('message.changePassword.newPasswordLengthValidate'), trigger: 'blur'}
          ],
          confirmPassword: [
            { required: true, message: this.$t('message.changePassword.confirmPasswordValidate'), trigger: 'blur' },
            { validator: confirmPasswordValidate, trigger: 'blur' },
          ],
        }
      }
    },

    props: {

      // 是否展示修改密码对话框
      isShow: Boolean,

    },

    methods: {

      // 展示状态变化时
      changeShowStatus(val) {
        this.resetFields();
        this.$emit('changeShowStatus', val);
      },

      // 提交修改密码
      submitChangePassword() {
        this.$refs.changePassword.validate(valid => {
          if (valid) {
            urlRequest({
              url: this.api.changePassword,
              method: 'POST',
              data: {
                'old_password': this.changePassword.oldPassword,
                'new_password': this.changePassword.newPassword,
              }
            }).then(res => {
              this.$Message.success(res.data.msg);
              this.$refs.changePassword.resetFields();
              this.isShowChangePassword = false;
            });
          }
        });
      },

      // 重置输入框
      resetFields() {
        this.$refs.changePassword.resetFields();
      },

    },

    computed: {

      // 是否展示修改密码对话框
      isShowChangePassword: {
        get() {
          return this.isShow;
        },
        set(val) {
          this.$emit('changeShowStatus', val);
          return val;
        }
      }

    }

  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "ChangePassword.scss";

</style>
